/* unplugin-vue-components disabled */import { render } from "./RechargeAgreement.vue?vue&type=template&id=354dac68&scoped=true"
import script from "./RechargeAgreement.vue?vue&type=script&lang=js"
export * from "./RechargeAgreement.vue?vue&type=script&lang=js"

import "./RechargeAgreement.vue?vue&type=style&index=0&id=354dac68&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354dac68"]])

export default __exports__